import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityActivityListDetails = () => {
  const columns = [
    { label: 'Opportunity', value: 'opportunity_name' },
    { label: 'Activity Type', value: 'activity_type' },
    { label: 'Date', value: (item) => fmtDate(item.date) },
    { label: 'Time', value: 'time' },
    { label: 'Description', value: 'description' },
    {
      label: 'Access Details',
      value: (activityId) => (
        <button onClick={() => handleAccessDetails(activityId)}>Access Details</button>
      ),
    },
  ];

  const handleAccessDetails = (activityId) => {
    // Handle access details action
    //console.log('Access Details', activityId);
    const encodedId = btoa(activityId);
    window.location.href = `/opportunity-activity/details/${encodedId}`;
  };

  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES.opportunityActivity} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityActivityListDetails;
